import axios from 'axios';
import { captureError } from '../';

export const fetchPlansByRanchId = async (ranchId) =>
  captureError(() => axios.get(`/api/plan/ranch/${ranchId}/`));

/**
 * Create - https://map.farmx.co/api/plan/create/
 * This endpoint allows for the creation of an installation plan.
 * It accepts all fields, although the following are the only required fields:
 * - ranch_name
 *  -ranch
 * @param {*} payload
 */
export const createPlan = async (payload) =>
  captureError(() => axios.post('/api/plan/create/', payload));

export const fetchPlanById = async (id) =>
  captureError(() => axios.get(`/api/plan/edit/${id}/`));

export const updatePlanById = async (id, payload) =>
  captureError(() => axios.put(`/api/plan/edit/${id}/`, payload));

export const patchPlanById = async (id, payload) =>
  captureError(() => axios.patch(`/api/plan/edit/${id}/`, payload));

export const deletePlanById = async (id) =>
  captureError(() => axios.delete(`/api/plan/edit/${id}/`));
